import { render, staticRenderFns } from "./MessageThreadCard.vue?vue&type=template&id=138b49c1&scoped=true"
import script from "./MessageThreadCard.vue?vue&type=script&lang=js"
export * from "./MessageThreadCard.vue?vue&type=script&lang=js"
import style0 from "./MessageThreadCard.vue?vue&type=style&index=0&id=138b49c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b49c1",
  null
  
)

export default component.exports